import { render, staticRenderFns } from "./AppHelp.vue?vue&type=template&id=e56aae36&"
import script from "./AppHelp.vue?vue&type=script&lang=js&"
export * from "./AppHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports